export default __webpack_public_path__ + "static/media/claims-icon.30f65cba.svg";